import React from 'react';
import { ConfirmPopup } from './../../../common/popup';
import { connect } from 'react-redux';
import { REDUCER_NAME, confirmDeleteTicker } from './../reducer';
import { I18n } from 'react-redux-i18n';
import Const from '../Const';

class ConfirmDeletePopup extends React.Component {
  isCoveredWarrant = () => {
    const { watchListId, currentCoveredWarrant } = this.props;
    return watchListId === currentCoveredWarrant;
  };

  handleConfirm = code => isApply => {
    const { confirm, watchListId, currentCoveredWarrant } = this.props;

    return confirm(
      isApply,
      code,
      this.isCoveredWarrant()
        ? Const.watchListType.CUSTOM_CW
        : Const.watchListType.CUSTOM,
    );
  };

  getPopupProps = () => {
    if (this.isCoveredWarrant()) {
      return {
        messages: [I18n.t('message.remove_cw_message')],
        title: I18n.t('message.remove_cw_title'),
      };
    }

    return {
      messages: [I18n.t('message.remove_message', { name: 'ticker' })],
      title: I18n.t('message.remove_title', { name: 'Ticker' }),
    };
  };

  render() {
    const { isShow, code } = this.props;

    return (
      <ConfirmPopup
        {...this.getPopupProps()}
        isShow={isShow}
        confirm={this.handleConfirm(code)}
        iconName={'icon-help'}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    isShow: state[REDUCER_NAME].showConfirmPopupDelete,
    code: state[REDUCER_NAME].organCodeDelete,
    watchListId: state[REDUCER_NAME].watchListId,
    currentCoveredWarrant: state[REDUCER_NAME].currentCoveredWarrant,
  };
};

const mapDispatchToProps = {
  confirm: confirmDeleteTicker,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfirmDeletePopup);
